import { Accordion, Badge, Button, Card } from "react-bootstrap";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { useCallback, useMemo, useState } from "react";
import { ArrowRightIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";

import { Default, Mobile } from "../Devices";
import LwcErrorBoundary from "../LwcErrorBoundary";
import RegistrationAccordionBody from "./RegistrationAccordionBody";
import RegistrationAccordionToggle from "./RegistrationAccordionToggle";
import { useCourseRegistration } from "../../services/CourseRegistrationProvider";

import "./RegistrationAccordion.scss";
import { useAuth } from "../../services/wp.auth.service";
import { userCanRegister } from "../../helpers/authHelpers";

const RegistrationAccordion = () => {
	const { user } = useAuth();
	const canRegister = useMemo(() => userCanRegister(user), [user]);

	const eventKey = "0";
	const { registeredCourses } = useCourseRegistration();

	const [activeKey, setActiveKey] = useState(null);
	const handleToggle = useCallback((evtKey) => {
		if (evtKey === activeKey) {
			setActiveKey(null);
		} else {
			setActiveKey(evtKey);
		}
	}, [activeKey]);

	// eslint-disable-next-line no-confusing-arrow
	const numberOfClasses = useMemo(() => registeredCourses?.length ? registeredCourses?.length : 0, [registeredCourses.length]);

	return canRegister && (
		<Accordion activeKey={activeKey} id="registration-accordion">
			<Card className="rounded-0">
				<Card.Header className="d-flex">
					<Default>
						<RegistrationAccordionToggle className="me-auto fs-16 fw-bold" eventKey={eventKey} handleToggle={handleToggle}>
							{activeKey === eventKey
								? <><EyeOffIcon className="i me-2" /> Hide Registration List</>
								: <><EyeIcon className="i me-2" /> Show Registration List</>}
						</RegistrationAccordionToggle>

						<div>
							<span className="me-4 text-blue fs-16 fw-bold">
								You are registering for {numberOfClasses} Classes.
							</span>

							<Button as={Link} to="/registration" variant="green">
								Confirm Registration&nbsp;
								<ArrowRightIcon />
							</Button>
						</div>
					</Default>
					<Mobile>
						<Button
							as={Link}
							className="w-100"
							size="block"
							to="/registration"
							variant="green"
						>
							{!!numberOfClasses && <Badge className="me-2">{numberOfClasses}</Badge>}
							Your Registration List&nbsp;
							<ArrowRightIcon />
						</Button>
					</Mobile>
				</Card.Header>

				<Accordion.Collapse className="overflow-auto flex-grow-0" eventKey="0">
					<Card.Body className="overflow-auto">
						<LwcErrorBoundary>
							<RegistrationAccordionBody />
						</LwcErrorBoundary>
					</Card.Body>
				</Accordion.Collapse>
			</Card>
		</Accordion>
	);
};

export default RegistrationAccordion;
